<template>
    <node-view-wrapper class="label-annotations-display" contenteditable="false">
        <span v-for="(annotation, index) in parsedAnnotations" :key="index">
            <report-label-annotation-item :annotation="annotation" />
            <span v-if="index < parsedAnnotations.length - 1" class="separator">, </span>
        </span>
        <report-label-annotation-item v-if="parsedAnnotations.length == 0" :annotation="{ id: '0', reportText: 'Selecione na imagem' }" />
    </node-view-wrapper>
</template>

<script>
import { evtBus } from '@/main';
import { nodeViewProps, NodeViewWrapper } from '@tiptap/vue-2'
import reportLabelAnnotationItem from '@/features/report/components/text/reportLabelAnnotationItem.vue';

export default {
    components: {
        NodeViewWrapper,
        reportLabelAnnotationItem,
    },

    props: nodeViewProps,

    data() {
        return {
            parsedAnnotations: []
        }
    },

    watch: {
        'node.attrs.annotationstext': {
            handler(newVal) {
                this.$nextTick(() => {
                    this.parsedAnnotations = this.parseAnnotationsString(newVal);
                });
            },
            immediate: true
        }
    },

    methods: {
        updateAnnotationsText(annotationsText) {
            this.$nextTick(() => {
                this.updateAttributes({
                    annotationstext: annotationsText
                })
            });
        },

        parseAnnotationsString(annotationsString) {
            try {
                return JSON.parse(annotationsString);
            } catch (error) {
                console.error('Error parsing annotations: ', error);
                return [];
            }
        }
    },
    
    mounted() {
        // this.$nextTick(() => {
        //     console.log('mounted: labelLocationsDisplay', this.node.attrs.labelid, this.node.attrs.annotationstext);
        // });
        // console.log('mounted: labelLocationsDisplay', this.node.attrs);
        evtBus.$on('evt_labelAnnotationsDisplay_update', (payload) => {
            if (payload.labelId === this.node.attrs.labelid) {
                this.updateAnnotationsText(JSON.stringify(payload.annotations));
                this.parsedAnnotations = payload.annotations;
            }
        });
    }
}
</script>

<style scoped>
@import '../../../styles/label_annotations.css';

</style>